import { configureStore } from '@reduxjs/toolkit';
import { baseApi, baseApiSla, notificationBaseApi } from '../services/baseSplit';
import accountReducer from './stateSlice/accountSlice';
import bookingReducer from './stateSlice/bookingSlice';
import userReducer from './stateSlice/userSlice';
import adminReducer from './stateSlice/adminSlice';
import bookingSummaryReducer from './stateSlice/bookingSummarySlice';
import driverSummaryReducer from './stateSlice/driverSummarySlice';
import flightSummarySlice from './stateSlice/flightSummarySlice';
import apiLogReducer from './stateSlice/apiLogSlice';
import slaPricingReducer from './stateSlice/slaDashboardSlice';
import alertReducer from './stateSlice/alertSlice';
import incidentReducer from './stateSlice/incidentSlice';
import paymentReducer from './stateSlice/paymentSlice';
import bookingPassportsReducer from './stateSlice/bookingPassportsSlice';
import slaAuditReducer from './stateSlice/slaAuditSlice';

export const store = configureStore({
    reducer: {
        [baseApi.reducerPath]: baseApi.reducer,
        [baseApiSla.reducerPath]: baseApiSla.reducer,
        [notificationBaseApi.reducerPath]: notificationBaseApi.reducer,
        account: accountReducer,
        booking: bookingReducer,
        user: userReducer,
        admin: adminReducer,
        bookingSummary: bookingSummaryReducer,
        driverSummary: driverSummaryReducer,
        flightSummary: flightSummarySlice,
        apiLog: apiLogReducer,
        slaPricing: slaPricingReducer,
        slaAudit: slaAuditReducer,
        alert: alertReducer,
        incidents: incidentReducer,
        payments: paymentReducer,
        bookingPassports: bookingPassportsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(
            baseApi.middleware,
            baseApiSla.middleware,
            notificationBaseApi.middleware
        ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
